import React, { useState, useRef } from "react";
import { Box, Typography, Button, Grid, FormControl, FormLabel, TextField, Select, MenuItem, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import styled from "styled-components";
import { postData } from "../../BaseUrl";
import Toast from "../../DynamicComponent/Toast";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "#D5D7DA", borderRadius: "10px" },
  },
}));

const labelStyle = { color: "#8F95B2", fontSize: "13px" };

export default function DocumentForm({ handleClose }) {
  const [form, setForm] = useState({ documentName: "", documentTitle: "", grade: "", academicYear: "2025-2026" });
  const [file, setFile] = useState(null);
  const [toast, setToast] = useState({ open: false, severity: "success", message: "" });
  const fileRef = useRef(null);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      Object.keys(form).forEach((k) => formData.append(k, form[k]));
      if (file) formData.append("file", file);
      await postData("admin/document/create", formData);
      setToast({ open: true, severity: "success", message: "Document uploaded successfully" });
      setTimeout(handleClose, 1200);
    } catch (_) {
      setToast({ open: true, severity: "error", message: "Upload failed" });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: "24px" }}>
      <Toast open={toast.open} handleClose={() => setToast({ ...toast, open: false })} severity={toast.severity} message={toast.message} />
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>Upload Document</Typography>
        <IconButton onClick={handleClose}><CloseIcon /></IconButton>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Document Name</FormLabel>
            <StyledTextField size="small" name="documentName" value={form.documentName} onChange={handleChange} placeholder="Enter document name" />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Document Title</FormLabel>
            <StyledTextField size="small" name="documentTitle" value={form.documentTitle} onChange={handleChange} placeholder="Enter document title" />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Grade</FormLabel>
            <StyledTextField size="small" name="grade" value={form.grade} onChange={handleChange} placeholder="e.g. Grade 3" />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Academic Year</FormLabel>
            <Select size="small" name="academicYear" value={form.academicYear} onChange={handleChange} sx={{ borderRadius: "10px" }}>
              <MenuItem value="2025-2026">2025-2026</MenuItem>
              <MenuItem value="2026-2027">2026-2027</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Box
            onClick={() => fileRef.current?.click()}
            onDrop={(e) => { e.preventDefault(); setFile(e.dataTransfer.files[0]); }}
            onDragOver={(e) => e.preventDefault()}
            sx={{ border: "2px dashed #D5D7DA", borderRadius: "10px", p: "24px", textAlign: "center", cursor: "pointer", backgroundColor: "#fafafa" }}
          >
            <input type="file" ref={fileRef} style={{ display: "none" }} onChange={(e) => setFile(e.target.files[0])} />
            <CloudUploadOutlinedIcon sx={{ fontSize: "40px", color: "#8F95B2" }} />
            <Typography sx={{ color: "#8F95B2", fontSize: "13px", mt: 1 }}>
              {file ? file.name : "Click to upload or drag and drop"}
            </Typography>
            <Typography sx={{ color: "#bbb", fontSize: "11px" }}>PDF, SVG, PNG, JPG or GIF (max. 800×400px)</Typography>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
        <Button onClick={handleClose} variant="outlined" sx={{ color: "#4caf50", borderColor: "#4caf50", borderRadius: "10px", textTransform: "none", px: 4 }}>Cancel</Button>
        <Button type="submit" sx={{ backgroundColor: "#1a237e", color: "#fff", borderRadius: "10px", textTransform: "none", px: 4, "&:hover": { backgroundColor: "#283593" } }}>Submitted</Button>
      </Box>
    </Box>
  );
}
